import { render, staticRenderFns } from "./AddPointsActionDescription.vue?vue&type=template&id=553fd97a&"
import script from "./AddPointsActionDescription.vue?vue&type=script&lang=js&"
export * from "./AddPointsActionDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports